import React from 'react';
import { useStyletron } from 'baseui';
import { Input, SIZE as INPUT_SIZE } from 'baseui/input';
import { KIND as NOTIFICATION_KIND, Notification } from 'baseui/notification';
import { LabelSmall, ParagraphSmall } from 'baseui/typography';
import { RELATIONSHIP_CREATOR_CONSTANTS, TEMPORAL_SCOPE } from '../../constants';
import { NOTIFICATION_OVERRIDES } from '../../overrides';
import type { TemporalScopeT } from '../../types/relationship';
type FrameRangeInputsProps = {
  temporalScope: TemporalScopeT;
  startFrame?: number;
  endFrame?: number;
  disabled?: boolean;
  startError?: string;
  endError?: string;
  onStartFrameChange: (value: number | undefined) => void;
  onEndFrameChange: (value: number | undefined) => void;
};

// Keeps the error border color when the input is focused.
// BaseUI overrides error styles with focus styles by default.
const errorFocusOverride = {
  Root: {
    style: ({
      $error,
      $isFocused,
      $theme
    }: any) => $error && $isFocused ? {
      borderTopColor: $theme.colors.inputBorderError,
      borderRightColor: $theme.colors.inputBorderError,
      borderBottomColor: $theme.colors.inputBorderError,
      borderLeftColor: $theme.colors.inputBorderError
    } : {}
  }
};
export const FrameRangeInputs = ({
  temporalScope,
  startFrame,
  endFrame,
  disabled,
  startError,
  endError,
  onStartFrameChange,
  onEndFrameChange
}: FrameRangeInputsProps) => {
  const [css, theme] = useStyletron();
  const isInterval = temporalScope === TEMPORAL_SCOPE.INTERVAL;
  const errorMessage = startError ?? endError;
  return <div>
      <div className={css({
      display: 'grid',
      gridTemplateColumns: isInterval ? '1fr 1fr' : '1fr',
      gap: theme.sizing.scale300
    })}>
        <div>
          <LabelSmall margin={0} marginBottom={theme.sizing.scale500}>
            {isInterval ? RELATIONSHIP_CREATOR_CONSTANTS.START_FRAME_LABEL : 'Frame'}
          </LabelSmall>
          <Input size={INPUT_SIZE.compact} type="number" value={startFrame ?? ''} disabled={disabled} error={!!startError} overrides={errorFocusOverride} onChange={e => {
          const val = e.currentTarget.value;
          onStartFrameChange(val === '' ? undefined : Number(val));
        }} />
        </div>
        {isInterval && <div>
            <LabelSmall margin={0} marginBottom={theme.sizing.scale500}>
              {RELATIONSHIP_CREATOR_CONSTANTS.END_FRAME_LABEL}
            </LabelSmall>
            <Input size={INPUT_SIZE.compact} type="number" value={endFrame ?? ''} disabled={disabled} error={!!endError} overrides={errorFocusOverride} onChange={e => {
          const val = e.currentTarget.value;
          onEndFrameChange(val === '' ? undefined : Number(val));
        }} />
          </div>}
      </div>
      {errorMessage && <Notification kind={NOTIFICATION_KIND.negative} overrides={NOTIFICATION_OVERRIDES}>
          <ParagraphSmall margin={0}>{errorMessage}</ParagraphSmall>
        </Notification>}
    </div>;
};